import React, { useState, useEffect } from "react";
import { LeftOutlined } from "@ant-design/icons";
import { useQuery, useMutation } from "@apollo/client";
import { Text } from "../../formitems/Index";
import { Qualification } from "../../../Queries/Manager Query/Qualifications_parameter/Qualification_Parameter";
import {
  getClientId,
  addAircraft_Form,
  Ground_Form,
  Simulator_Form,
  Fleets,
  Simulator_Query,
  Aircraft_Query,
  Ground_Query,
} from "../../../Queries/Manager Query/Manager_Form/Forms_Query";
import { Switch } from "antd";
import { Menu, Dropdown, InputNumber } from "antd";
import firebase from "../../../Firebase/firebase";
import { Select } from "antd";
import { DownOutlined } from "@ant-design/icons";
import { Link } from "react-router-dom";
import SimulatorForm from "./simulatoForm";
import AircraftForms from "./Aircraftforms";
import GroundForms from "./Groundforms";
import EditAircraftForm from "./EditAircraftForm";
import EditSimulator from "./EditSimulator";
import EditGround from "./EditGround";
const Forms = () => {
  const [search, setsearch] = useState("");
  const [isEdit, setisEdit] = useState(false);
  const [toggle, settoggle] = useState(true);
  const [fleetss, setFleetss] = useState("");
  const [isView, setisView] = useState(false);
  const [currentFormData, setCurrentFormData] = useState({});
  const [validity, setvalidity] = useState(0);
  const [dropdown, setdropdown] = useState("");
  const [dropdown2, setdropdown2] = useState("");
  const [cost, setcost] = useState(0);
  const [users, setusers] = useState({});
  const catagoryy = [
    { catagory: "Ground" },
    { catagory: "Simulator" },
    { catagory: "Aircraft" },
  ];
  const [catagories, setCatagories] = useState("");
  useEffect(() => {
    firebase.auth().onAuthStateChanged(async (user) => {
      if (user) {
        const token = await user.getIdToken();
        const idTokenResult = await user.getIdTokenResult();
        setusers({
          user: user,
          token: idTokenResult,
          jwt: token,
        });
      } else console.log("SIGNED OUT");
    });
  }, []);
  console.log(currentFormData);
  const { data: getclient } = useQuery(getClientId, {
    variables: { id: users?.token?.claims?.user_id },
  });
  const { data } = useQuery(Qualification, {
    variables: {
      active: toggle,
      id: getclient?.aatmsv4_users[0]?.client.clientsid,
    },
  });
  const { data: dataaa } = useQuery(Fleets, {
    variables: { id: getclient?.aatmsv4_users[0]?.client.clientsid },
  });
  const { data: simulatorQuery } = useQuery(Simulator_Query, {
    variables: {
      fleet: fleetss,
      id: getclient?.aatmsv4_users[0]?.client.clientsid,
    },
  });
  const { data: aircraftQuery } = useQuery(Aircraft_Query, {
    variables: {
      fleet: fleetss,
      id: getclient?.aatmsv4_users[0]?.client.clientsid,
    },
  });
  const { data: groundQuery } = useQuery(Ground_Query, {
    variables: {
      fleet: fleetss,
      id: getclient?.aatmsv4_users[0]?.client.clientsid,
    },
  });
  const [aircraftAdd, { data: air }] = useMutation(addAircraft_Form, {
    refetchQueries: [
      {
        query: Aircraft_Query,
        variables: {
          fleet: fleetss,
          id: getclient?.aatmsv4_users[0]?.client.clientsid,
        },
      },
    ],
  });
  const [simulatorAdd, { data: addsimform }] = useMutation(Simulator_Form, {
    refetchQueries: [
      {
        query: Simulator_Query,
        variables: {
          fleet: fleetss,
          id: getclient?.aatmsv4_users[0]?.client.clientsid,
        },
      },
    ],
  });
  const [groundFormAdd, { data: ground }] = useMutation(Ground_Form, {
    refetchQueries: [
      {
        query: Ground_Query,
        variables: {
          fleet: fleetss,
          id: getclient?.aatmsv4_users[0]?.client.clientsid,
        },
      },
    ],
  });
  const editfleet = () => {
    setisEdit(true);
  };
  const View = () => {
    setisView(true);
  };
  const closeForm = () => {
    setisEdit(false);
    setisView(false);
  };
  const menu = (data) => (
    <Menu>
      <Menu.Item>
        <Link
          onClick={() => {
            setCurrentFormData(data);
            editfleet();
          }}
        >
          Edit
        </Link>
      </Menu.Item>
      {/* <Menu.Item>
        <Link onClick={() => {
          setCurrentFormData(data)
          View()
        }}>View</Link>
      </Menu.Item> */}
    </Menu>
  );
  const handleFormFields = (v, fieldName) => {
    switch (fieldName) {
      case "aircraftformname":
        setCurrentFormData({ ...currentFormData, aircraftformname: v });
        break;
      case "caption1":
        setCurrentFormData({ ...currentFormData, caption1: v });
        break;
      case "caption2":
        setCurrentFormData({ ...currentFormData, caption2: v });
        break;
      case "caption3":
        setCurrentFormData({ ...currentFormData, caption3: v });
        break;
      default:
        break;
    }
  };
  const Option = Select.Option;
  return (
    <div className="animate__animated animate__fadeIn">
      <div className={isEdit || isView ? "hide-element" : ""}>
        <div className="category-title">Forms</div>
        <div className="table-body-container">
          <div className="table-body-header">All Forms</div>
          <div className="client-list-divider"></div>
          <div className="table-container">
            <div className="table-header-container">
              <div className="display-record">
                <span>records 10</span>
              </div>
              <div className="display-record">
                <Select
                  value={fleetss ? fleetss : "Select your Fleet"}
                  onChange={(e) => setFleetss(e)}
                >
                  {dataaa?.aatmsv4_fleets?.map((el, i) => (
                    <Option key={i} value={el?.fleetsid}>
                      {el?.aircraft}
                    </Option>
                  ))}
                </Select>
              </div>
              <div className="display-record">
                <Select
                  value={catagories ? catagories : "Select your Catagory"}
                  onChange={(e) => setCatagories(e)}
                >
                  {catagoryy?.map((el, i) => (
                    <Option key={i} value={el?.catagory}>
                      {el?.catagory}
                    </Option>
                  ))}
                </Select>
              </div>
              <div className="search-bar">
                <span>Search</span>
                <input
                  type="text"
                  value={search}
                  onChange={(e) => setsearch(e.target.value)}
                />
              </div>
            </div>
            {catagories === "Simulator" ? (
              <SimulatorForm
                catagories={catagories}
                simulatorQuery={simulatorQuery}
                search={search}
                DownOutlined={DownOutlined}
                Dropdown={Dropdown}
                menu={menu}
              />
            ) : null}
            {catagories === "Aircraft" ? (
              <AircraftForms
                catagories={catagories}
                aircraft={aircraftQuery}
                search={search}
                DownOutlined={DownOutlined}
                Dropdown={Dropdown}
                menu={menu}
              />
            ) : null}
            {catagories === "Ground" ? (
              <GroundForms
                catagories={catagories}
                ground={groundQuery}
                search={search}
                DownOutlined={DownOutlined}
                Dropdown={Dropdown}
                menu={menu}
              />
            ) : null}
          </div>
        </div>
        <div className="print-email-container">
          <button className="print-button">
            <i className="fa fa-print" />
            Print
          </button>
          <button className="email-button">
            <i className="fa fa-envelope" />
            Email
          </button>
        </div>
      </div>
      {/* Edit Quialification  */}
      <div className={isEdit ? "" : "hide-element"}>
        {catagories === "Aircraft" ? (
          <EditAircraftForm
            aircraftAdd={aircraftAdd}
            name={getclient?.aatmsv4_users[0]?.client.clientname}
            catagories={catagories}
            handleFormFields={handleFormFields}
            closeForm={closeForm}
            currentFormData={currentFormData}
          />
        ) : null}
        {catagories === "Simulator" ? (
          <EditSimulator
            simulatorAdd={simulatorAdd}
            name={getclient?.aatmsv4_users[0]?.client.clientname}
            catagories={catagories}
            handleFormFields={handleFormFields}
            closeForm={closeForm}
            currentFormData={currentFormData}
          />
        ) : null}
        {catagories === "Ground" ? (
          <EditGround
            groundFormAdd={groundFormAdd}
            name={getclient?.aatmsv4_users[0]?.client.clientname}
            catagories={catagories}
            handleFormFields={handleFormFields}
            closeForm={closeForm}
            currentFormData={currentFormData}
          />
        ) : null}
      </div>
      {/* View */}
      {/* <div className={isView ? "" : "hide-element"}>
        <div className="category-title">
          <span className="client-back" onClick={() => closeForm()}>
            {<LeftOutlined />} Qualification
            </span>
            View {catagories === "Aircraft"?"Aircraft": null}{catagories === "Simulator"?"Simulator": null}{catagories === "Ground"?"Ground": null} Form
          </div>
        <div className="toggle-form-container">
          <div className="input-box-container">
            <div className="input-box-title">
            </div>
          </div>
          <div className="input-box-container">
            <Text title="Client" disabled value={currentFormData?.clientname} onChange={(e) => handleFormFields(e.target.value, 'qcode')} />
            <Text title="Manager" disabled value={currentFormData?.manager?.managername} onChange={(e) => handleFormFields(e.target.value, 'qcode')} />
            <Text title="Qualification Name" disabled value={currentFormData.qualification} onChange={(e) => handleFormFields(e.target.value, "qualification")} />
            <Text title="Caption1" disabled value={currentFormData.caption1} onChange={(e) => handleFormFields(e.target.value, 'caption1')} />
            <Text title="Caption2" disabled value={currentFormData.caption2} onChange={(e) => handleFormFields(e.target.value, 'caption2')} />
            <Text title="Caption3" disabled value={currentFormData.caption3} onChange={(e) => handleFormFields(e.target.value, 'caption3')} />
            <Text title="Cost" disabled value={currentFormData.cost} onChange={(e) => handleFormFields(e.target.value, 'cost')} />
            <Text title="Validity" disabled value={currentFormData.validity} onChange={(e) => handleFormFields(e.target.value, 'validity')} />
            <Text title="Validity" disabled value={currentFormData.active ? 'Yes' : 'No'} onChange={(e) => handleFormFields(e.target.value, 'validity')} />
          </div>
          <button className="submit-button" onClick={() => {
            closeForm()
            // UpdateNotificationWithIcon("success")
          }}>Print</button>
          <button onClick={() => closeForm()} className="cancel-button">
            Cancel
          </button> */}
      {/* </div> */}
      {/* </div> */}
    </div>
  );
};

export default Forms;
